module.exports = __webpack_public_path__ + "static/img/why-6.799f049f.jpg";